import React from 'react';
import ReactDOM from 'react-dom';

import { T } from '../../../../common/locale/translate';

export default class Transfer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      pristine: true,
      transfer: null
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  componentWillReceiveProps = nextProps => {
    this.setState({
      ...this.state,
      transfer: nextProps.transfer_values || null,
      pristine: false
    });
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => {
    const isChecked = value => this.state.transfer === value;

    return (
      <div
        className={
          'transfers-list_wrapper' + (this.state.active ? 'active' : '')
        }
        ref={() => {
          this.returnSearchedValue = this.returnSearchedValue.bind(this);
        }}
      >
        <ul className="transfers-list">
          <li className="item">
            <input
              type="checkbox"
              id="withTransfer"
              name="transfer"
              onChange={this.handleChange}
              value="2"
              checked={isChecked('2')}
            />
            <label htmlFor="withTransfer">{T('with_transfer')}</label>
          </li>
          <li className="item">
            <input
              type="checkbox"
              id="withoutTransfer"
              name="transfer"
              onChange={this.handleChange}
              value="1"
              checked={isChecked('1')}
            />
            <label htmlFor="withoutTransfer">{T('without_transfer')}</label>
          </li>
        </ul>
      </div>
    );
  };

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false });
    }
  };

  handleChange = event => {
    const selectedValue = event.target.value;

    this.setState(prevState => ({
      transfer: prevState.transfer === selectedValue ? null : selectedValue
    }));
  };

  handleClose = () => this.setState({ active: false });

  handleFocus = () => this.setState({ active: true });

  returnSearchedValue = () => {
    return this.state.transfer || false;
  };
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/transfer.js